import { useState } from "react";
import { Download, ArrowRight } from "lucide-react";
import { GuideModal } from "./GuideModal";

export const HeroSection = () => {
  const [guideModalOpen, setGuideModalOpen] = useState(false);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="hero-section" data-testid="hero-section">
      <div 
        className="hero-bg"
        style={{
          backgroundImage: `url('https://customer-assets.emergentagent.com/job_b0be9df2-3d3f-47b3-ad10-6eae685c0f13/artifacts/hkyeha88_dreamstime_xl_139300138.jpg')`
        }}
      />
      <div className="hero-overlay" />
      
      <div className="hero-content animate-hidden animate-fadeInUp">
        <div className="gold-line animate-hidden animate-fadeIn animate-delay-200" />
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 font-serif">
          Next Chapter Moves NC
        </h1>
        <p className="text-xl md:text-2xl text-white/90 font-light mb-4 leading-relaxed">
          Real Estate Guidance for the Next Chapter of Life
        </p>
        <p className="text-base md:text-lg text-white/75 mb-10 max-w-2xl leading-relaxed">
          Helping North Carolina homeowners simplify, downsize, relocate, or prepare for what's next — with clear guidance, steady communication, and no pressure.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="#contact" 
            onClick={(e) => scrollToSection(e, "#contact")}
            className="btn-primary"
            data-testid="hero-cta-conversation"
          >
            Start a Conversation
            <ArrowRight size={18} />
          </a>
          <button 
            onClick={() => setGuideModalOpen(true)}
            className="btn-secondary"
            data-testid="hero-cta-guide"
          >
            <Download size={18} />
            Download Free Guide
          </button>
        </div>
      </div>

      <GuideModal isOpen={guideModalOpen} onClose={() => setGuideModalOpen(false)} />
    </section>
  );
};
